import { CodeEditor, OnMount, OnValidate } from '~src/components/CodeEditor/CodeEditor';

import { useBookingRuleFormContext } from '../hooks';

interface Props {
  onValidate: OnValidate;
  onMount?: OnMount;
}

export function RuleEditor(props: Props) {
  const { setValue, watch } = useBookingRuleFormContext();

  return (
    <CodeEditor
      options={{ minimap: { enabled: false }, automaticLayout: true }}
      onChange={r => setValue('json', r!)}
      path="inmemory://model/rule.json"
      value={watch('json')}
      language="json"
      {...props}
    />
  );
}
